import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCreateVendorProfileMutation } from "store/services/vendorProfileApi";
import VendorProfileForm from "../../../../../components/VendorProfile/VendorProfileForm";

const VendorProfileCreateScreen = () => {
  const navigate = useNavigate();
  const breadcrumbs = [
    {
      title: "Vendor-Profile",
      path: "/app/crm/vendor-profile/list",
    },
    {
      title: "New Vendor Profile",
    },
  ];

  const [createVendorProfile, { isLoading: creatingVendorProfile }] =
    useCreateVendorProfileMutation();

  const handleVendorProfileCreate = async (data) => {
    try {
      await createVendorProfile(data).unwrap();
      navigate(breadcrumbs[0].path);
      toast.success("Vendor Profile created successfully");
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Vendor Profile!"
      );
    }
  };

  useAppMeta("New Vendor Profile");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingVendorProfile}>
      <BreadcrumbLayout.Paper>
        <VendorProfileForm
          isBusy={creatingVendorProfile}
          onSubmit={handleVendorProfileCreate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VendorProfileCreateScreen;
